import {
  IBankTransactionData,
  IBankTransactionGraphData,
  IBankTransactionRawData,
} from '@common/interfaces/bankTransactions'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

export default combineReducers({
  bankTransactions: createLoadingDataReducer<IBankTransactionData>(
    [actions.LIST_TRANSACTIONS_REQUEST, actions.LIST_TRANSACTION_DETAIL_REQUEST],
    [actions.UPDATE_TRANSACTIONS_REQUEST],
  ),
  bankTransactionsRaw: createLoadingDataReducer<IBankTransactionRawData>(
    [actions.LIST_TRANSACTION_RAW_REQUEST],
    [],
    false,
    [actions.HIDE_TRANSACTIONS],
  ),
  bankTransactionsGraph: createLoadingDataReducer<IBankTransactionGraphData>(
    [actions.LIST_TRANSACTION_GRAPH_REQUEST],
    [],
    false,
    [actions.HIDE_TRANSACTIONS],
  ),
})
